import {
    IconDefinition,
    faCaretDown,
    faCaretUp
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Card } from 'components';
import { Flex } from 'components/Flex';
import { P } from 'components/Typography/Typography';
import { useDropdown } from 'hooks/useDropdown';
import React from 'react';
import styled from 'styled-components';

export interface IDropdown {
  items?: Array<{
    label: string;
    onClick: () => void;
    icon: IconDefinition;
  }>;
  children?: React.ReactNode;
  customDropdown?: React.ReactNode;
  bgColor?: string;
  width?: string;
}

const Root = styled.div`
  position: relative;
`;


const WrapperChildren = styled(Flex)<{ bgColor?: string }>`
  cursor: pointer;
  border-radius: 5px 0 0 5px;
  background-color: ${({ bgColor, theme }) =>
    bgColor || theme.palette.neutral.tablePagination};
`;

const WrapperDropdown = styled.div`
  ${({ theme }) => `
    right: 0;
    position: absolute;
    top: 100%;
    margin: 0px 20px 0px 20px;
    z-index: 1000;
  `}
`;

const StyledTypography = styled(P)`
  ${({ theme }) => `
    padding: 8px 35px 8px 8px;
    white-space: nowrap;
    cursor: pointer;
    font-size: 14px;

    &:hover {
      background-color: ${theme.palette.neutral.lightBlue};
    }
  `}
`;

const StyledCard = styled(Card)`
  padding: 8px;
  border: 1px solid #dadada;
  border-radius: 5px;
`;

export const Dropdown: React.FC<IDropdown> = ({
  items,
  children,
  customDropdown,
  bgColor,
  width
}) => {
  const { buttonRef, optionsRef, isVisible, setIsVisible } = useDropdown(false);

  const handleClick = (onClick: () => any) => () => {
    onClick();
    setIsVisible(false);
  };

  return (
    <Root>
      <WrapperChildren
        ref={buttonRef}
        role="button"
        aria-hidden="true"
        alignItems="center"
        bgColor={bgColor}
      >
        {children}

        {/* TODO: right-align the WrapperDropdown with this caret */}

        <Box mx={2}>
          <FontAwesomeIcon icon={isVisible? faCaretUp : faCaretDown} />
        </Box>
      </WrapperChildren>

      {isVisible && (
        <WrapperDropdown ref={optionsRef}>
          <StyledCard p={3}>
            {items?.map(({ label, onClick, icon }) => (
              <div
                key={label}
                onClick={handleClick(onClick)}
                aria-hidden="true"
                role="button"
              >
                <StyledTypography variant="body" color="grey">
                  {icon && <FontAwesomeIcon style={{
                    paddingRight: '10px'
                  }} icon={icon} />}
                  {label}
                </StyledTypography>
              </div>
            ))}

            {customDropdown && customDropdown}
          </StyledCard>
        </WrapperDropdown>
      )}
    </Root>
  );
};
